import * as React from "react";
import {Icon} from "./Icon";

export class StartIcon extends Icon {

  render() {
    return <Icon {...this.props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
        <polygon points="8 42 40 42 40 26 24 16 8 26 8 42"/>
        <polygon points="2 26 24 12 46 26 46 20 24 6 2 20 2 26"/>
      </svg>
    </Icon>;
  }
}
